import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import cannedMgmt from './cannedMgmt.json';
import captain from './captain.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import crm from './crm.json';
import crmReports from './crmReports.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import landingPages from './landingPages.json';
import forms from './forms.json';
import sites from './sites.json';
import marketingFlows from './marketingFlows.json';
import variableLibrary from './variableLibrary.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import workflows from './workflows.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import yearInReview from './yearInReview.json';
import scheduledMessages from './scheduledMessages.json';
import bulkBroadcasts from './bulkBroadcasts.json';
import emailMkt from './emailMkt.json';
import segmentImport from './segmentImport.json';
import campaigns from './campaigns.json';
import conversionMapping from './conversionMapping.json';
import metaCapiPixels from './metaCapiPixels.json';
import metaAds from './metaAds.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...cannedMgmt,
  ...captain,
  ...chatlist,
  ...companies,
  ...components,
  ...crm,
  ...crmReports,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...landingPages,
  ...forms,
  ...sites,
  ...marketingFlows,
  ...variableLibrary,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...whatsappTemplates,
  ...workflows,
  ...contentTemplates,
  ...mfa,
  ...yearInReview,
  ...scheduledMessages,
  ...bulkBroadcasts,
  ...emailMkt,
  ...segmentImport,
  ...campaigns,
  ...conversionMapping,
  ...metaCapiPixels,
  ...metaAds,
};
